module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2AQMAAAC2i/ieAAAABlBMVEVHcEzY2NjdWfUoAAAAAXRSTlMAQObYZgAAABxJREFUGNNjYMAN/gxmWv4/CDwgmh7s/sFCYwMAC3xNNaM9EqsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/images/ico_evoucher_plus_off.png
// module id = BwTj
// module chunks = 0